<div class="ivy" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px" fxFill>
  <form [formGroup]="ivyForm" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
    <dashboard-module-item-core [dialogData]="dialogData" formControlName="moduleItemCore"></dashboard-module-item-core>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <mat-checkbox formControlName="hideInfo">Hide Info Part</mat-checkbox>
    </div>
    <div fxLayout="column">
      <label>Set Zone as Correct</label>
      <mat-radio-group
        fxLayout="row"
        formControlName="correctZone"
        fxLayoutAlign="start center"
        fxLayoutGap="30px"
        fxFlexOffset="10px"
      >
        <mat-radio-button value="0">Top</mat-radio-button>
        <mat-radio-button value="1">Bottom</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="ivy__zone" fxLayout="column" fxLayoutGap="15px">
      <label><b>Top Zone</b></label>
      <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="20px" fxFlexOffset="10px">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="20">
          <label class="ivy__zone-label">Color :&#160;</label>
          <input
            [colorPicker]="topZoneColor.value"
            [style.background]="topZoneColor.value"
            (colorPickerChange)="topZoneColor.setValue($event)"
            class="ivy__zone-color-picker"
          />
        </div>
        <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="start center" fxFlex="80">
          <mat-checkbox formControlName="defaultTopZoneAudio">Default audio</mat-checkbox>
          <dashboard-audio-upload
            [isSelectAudioDisabled]="defaultTopZoneAudio.value"
            formControlName="topZoneAudio"
            [isEdit]="isEdit"
            [isFileToEdit]="isTopZoneAudioFileToEdit"
            [filePathInput]="topZoneAudioFilePath"
            [keyForUpload]="keyForUpload"
            [idsForUpload]="idsForUpload"
          >
          </dashboard-audio-upload>
        </div>
      </div>
      <mat-tab-group
        mat-align-tabs="end"
        animationDuration="0ms"
        (selectedTabChange)="dashboardModuleItemCore.selectTemplateLanguage($event)"
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
          <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
            <ng-container formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
              <ng-container *ngIf="item.get('language').value === selectedLanguage.code">
                <mat-form-field
                  [formGroupName]="i"
                  fxFlex="50"
                  *ngIf="item.get('identifier').value === ModuleItemAvailableAttribute.TOP_ZONE_GROUP"
                >
                  <input matInput formControlName="translation" placeholder="Top Zone Group" maxlength="20" />
                </mat-form-field>
                <mat-form-field
                  [formGroupName]="i"
                  fxFlex="50"
                  *ngIf="item.get('identifier').value === ModuleItemAvailableAttribute.TOP_ZONE_WORD"
                >
                  <input matInput formControlName="translation" placeholder="Top Zone Word" maxlength="20" />
                </mat-form-field>
              </ng-container>
            </ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="ivy__zone" fxLayout="column" fxLayoutGap="15px">
      <label><b>Bottom Zone</b></label>
      <div fxLayout="row" fxLayoutAlign="space-around" fxLayoutGap="20px" fxFlexOffset="10px">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="20">
          <label class="ivy__zone-label">Color :&#160;</label>
          <input
            [colorPicker]="bottomZoneColor.value"
            [style.background]="bottomZoneColor.value"
            (colorPickerChange)="bottomZoneColor.setValue($event)"
            class="ivy__zone-color-picker"
          />
        </div>
        <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="start center" fxFlex="80">
          <mat-checkbox formControlName="defaultBottomZoneAudio">Default audio</mat-checkbox>
          <dashboard-audio-upload
            [isSelectAudioDisabled]="defaultBottomZoneAudio.value"
            formControlName="bottomZoneAudio"
            [isEdit]="isEdit"
            [isFileToEdit]="isBottomZoneAudioFileToEdit"
            [filePathInput]="bottomZoneAudioFilePath"
            [keyForUpload]="keyForUpload"
            [idsForUpload]="idsForUpload"
          >
          </dashboard-audio-upload>
        </div>
      </div>
      <mat-tab-group
        mat-align-tabs="end"
        animationDuration="0ms"
        (selectedTabChange)="dashboardModuleItemCore.selectTemplateLanguage($event)"
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
          <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
            <ng-container formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
              <ng-container *ngIf="item.get('language').value === selectedLanguage.code">
                <mat-form-field
                  [formGroupName]="i"
                  fxFlex="100"
                  *ngIf="item.get('identifier').value === ModuleItemAvailableAttribute.BOTTOM_ZONE_GROUP"
                >
                  <input matInput formControlName="translation" placeholder="Bottom Zone Group" maxlength="20" />
                </mat-form-field>
                <mat-form-field
                  [formGroupName]="i"
                  fxFlex="100"
                  *ngIf="item.get('identifier').value === ModuleItemAvailableAttribute.BOTTOM_ZONE_WORD"
                >
                  <input matInput formControlName="translation" placeholder="Bottom Zone Word" maxlength="20" />
                </mat-form-field>
              </ng-container>
            </ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="ivy__zone" fxLayout="column">
      <label><b>Drag Word</b></label>
      <div fxLayout="row" fxFlex="35" fxLayoutAlign="start center" fxFlexOffset="10px">
        <label class="ivy__zone-label">Color:&#160;</label>
        <input
          [colorPicker]="dragWordColor.value"
          [style.background]="dragWordColor.value"
          (colorPickerChange)="dragWordColor.setValue($event)"
          class="ivy__zone-color-picker"
        />
      </div>
      <div fxLayout="column">
        <mat-tab-group
          mat-align-tabs="end"
          animationDuration="0ms"
          (selectedTabChange)="dashboardModuleItemCore.selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-template matTabContent>
              <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
                <ng-container
                  *ngIf="
                    item.get('language').value === selectedLanguage.code &&
                    item.get('identifier').value === ModuleItemAvailableAttribute.DRAG_WORD
                  "
                >
                  <mat-form-field [formGroupName]="i" fxFlex="100">
                    <input matInput formControlName="translation" placeholder="Drag Word" maxlength="20" />
                  </mat-form-field>
                </ng-container>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </form>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
  >
    <button mat-raised-button color="primary" (click)="closeModuleItemDialog()">
      {{ 'Cancel' | uppercase }}
    </button>
    <button mat-raised-button color="primary" (click)="saveModuleItem()">
      {{ 'Save' | uppercase }}
    </button>
  </div>
</div>
